<template>
  <div class="schedule-index">
    <div class="row mt-4">
      <div class="col-md-8">
        <input class="input form-control" @keypress.enter="find()" v-model="query.generic"
          placeholder="Pesquisar por nome">
        <search-icon @click="find()" class="icon icon-within" />
      </div>

      <button class="col-md-2 ml-2 btn-sm btn-outline" :class="{ 'btn-outline-active': showFilter }"
        @click="showFilter = !showFilter">
        Filtros
        <chevron-down-icon class="fa-angle-right" :class="{ 'rotate-90': showFilter }" />
      </button>

      <button v-if="changeQuery" @click="find()" class="btn btn-link">
        Aplicar filtros ({{ numberOfBadges }})
      </button>
    </div>

    <!-- Badges -->
    <div class="row">
      <div class="col-md-12">
        <BadgeFilters :filters="badgeFilters" :query="query" @clearBadge="find" @clearAllBadges="find"
          :amount-changed="updateNumberOfBadges" />
      </div>
    </div>

    <!-- Filters -->
    <template v-if="showFilter">
      <div class="row mt-4">
        <div class="col-md-3">
          <label>Contas</label>
          <Select2 :options="filterAccount" v-model="query.accountId" title-load="Carregando contas..."
            :disabled="!filterAccount" />
        </div>

        <div class="col-md-3">
          <label>Criado por</label>
          <Select2 :options="filterCreatedBy" v-model="query.createdBy" title-load="Carregando usuários..."
            :disabled="!filterCreatedBy" />
        </div>

        <div class="col-md-3">
          <label>Atualizado por</label>
          <Select2 :options="filterUpdatedBy" v-model="query.updatedBy" title-load="Carregando usuários..."
            :disabled="!filterUpdatedBy" />
        </div>

        <div class="col-md-3">
          <label>Ativo</label>
          <select v-model="query.enable" class="form-control">
            <option value="">Todos</option>
            <option value="true">Sim</option>
            <option value="false">Não</option>
          </select>
        </div>
      </div>

      <div class="row mt-4">
        <div class="col-md-3">
          <label>App</label>
          <Select2 :options="filterApp" v-model="query.appName" :disabled="!filterApp" />
        </div>

        <div class="col-md-3">
          <label>Tipo de data</label>
          <select v-model="query.periodType" class="form-control">
            <option v-for="option in filterDateType.table" :key="option.value" :value="option.value">{{ option.label }}
            </option>
          </select>
        </div>

        <div class="col-md-3">
          <label>Data inicial</label>
          <input type="datetime-local" class="form-control" v-model="query.startDate">
        </div>

        <div class="col-md-3">
          <label>Data final</label>
          <input type="datetime-local" class="form-control" v-model="query.endDate">
        </div>
      </div>
    </template>

    <!-- Botão de exportação -->
    <div class="row mt-4">
      <div class="col-md-12">
        <button class="btn btn-primary mt-1 mr-1" @click="createReport()" :disabled="disabledExport">
          Baixar relatório
        </button>
      </div>
    </div>

    <!-- Info -->
    <div class="row">
      <div class="col-sm-12">

        <small class="mr-3">
          {{ infoTotalModels }}
        </small>

        <button class="btn btn-outline btn-sm ml-2" @click="changeCheckAll()">
          {{ checkAll ? 'Desmarcar todos' : 'Selecionar todos' }}
        </button>

        <div class="float-right" style="display: inline-flex;align-items: center;">
          <small class="mr-2" style="white-space: nowrap">Ordenar por:</small>
          <select v-model="order" @change="updateOrder(order)" class="browser-default custom-select">
            <option :value="['updated_at', 'desc']">Data de atualização</option>
            <option :value="['created_at', 'desc']">Data de criação</option>
            <option :value="['execute_in', 'desc']">Data de agendado</option>
            <option :value="['executed_at', 'desc']">Data de execução</option>
          </select>
        </div>
      </div>
    </div>

    <!-- Table -->
    <div class="row">
      <div class="col-sm-12">
        <Table :key="tableKey" :eventSchedules="schedules" :getAccountName="getAccountName" :checkAllRow="checkAllRow"
          @changeCheckAllRow="changeCheckAllRow" @changeCheckRow="changeCheckRow" />

        <div class="row">
          <div class="col-md-12 my-1">
            <Pagination v-model="meta.currentPage" :total-count="meta.totalCount" :total-pages="meta.totalPages"
              @pagination="pagination" />
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import BadgeFilters from '@/components/shares/BadgeFilters'
import CheckedModels from '@/mixins/CheckedModels'
import GetAccount from '@/mixins/GetAccount'
import GlobalLoading from '@/mixins/GlobalLoading'
import Pagination from '@/components/shares/specialTag/Pagination'
import ModelMapper from '@/mixins/ModelMapper'
import Select2 from '@/components/shares/Select2'
import Table from './Table.vue'

import { ChevronDownIcon, SearchIcon } from 'vue-feather-icons'
import { Filter } from '@/models/filter'

const lastHour = () => {
  const date = new Date()
  date.setHours(date.getHours() - 1)
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  const hours = String(date.getHours()).padStart(2, '0')
  return `${year}-${month}-${day}T${hours}:00`
}

export default {
  components: {
    BadgeFilters,
    ChevronDownIcon,
    Pagination,
    SearchIcon,
    Select2,
    Table
  },
  computed: {
    badgeFilters() {
      return [
        this.filterEndDate,
        this.filterStartDate,
        this.filterDateType,
        this.filterAccount,
        this.filterApp,
        this.filterEnable,
        this.filterCreatedBy,
        this.filterUpdatedBy
      ];
    },
    disabledExport() {
      return !this.schedules.some(s => s.checked) && !this.checkAll
    },
    schedules() {
      return this.getModels || []
    }
  },
  created() {
    this.defaultModelSetting.updateQueryURL = true

    this.order = ['created_at', 'desc']
    this.$set(this.query, 'periodType', 'created_at')
    this.$set(this.query, 'enable', '')
    if (this.$utils.isEmpty(this.query.startDate))
      this.$set(this.query, 'startDate', lastHour())

    this.buildFilters()

    this.asyncTemplateSelect({
      byURL: true,
      pagination: true
    })
  },
  data() {
    return {
      filterAccount: null,
      filterApp: null,
      filterEnable: null,
      filterCreatedBy: null,
      filterUpdatedBy: null,
      filterDateType: new Filter({
        key: 'periodType',
        label: 'Tipo de data',
        type: 'select',
        table: [
          { label: 'Data de criação', value: 'created_at' },
          { label: 'Data de atualização', value: 'updated_ait' },
          { label: 'Agendado para', value: 'execute_in' },
          { label: 'Executado em', value: 'executed_at' }
        ]
      }),
      filterEndDate: new Filter({
        key: 'endDate',
        label: 'Data final',
        type: 'date'
      }),
      filterStartDate: new Filter({
        key: 'startDate',
        label: 'Data inicial',
        type: 'date'
      }),
      nameModel: 'EventSchedule',
      numberOfBadges: 0,
      showFilter: false,
      tableKey: 0
    }
  },
  methods: {
    buildPath() {
      return 'admin/event_schedules'
    },
    changeCheckAllRow(value) {
      this.changeCheck({ checkAllRow: value, sources: this.schedules })
    },
    changeCheckRow() {
      this.changeCheck({ sources: this.schedules })
    },
    changeCheckAll() {
      this.changeCheck({ checkAll: !this.checkAll, sources: this.schedules })
    },
    createReport() {
      let params
      let amount

      if (this.checkAll) {
        params = this.buildParams()
        amount = this.meta.totalCount
      } else {
        const ids = this.schedules.filter(s => s.checked).map(s => s.id)
        params = { q: { id: ids } }
        amount = ids.length
      }

      if (!confirm(`Exportar ${amount} Agendamento(s).\nTem certeza?`))
        return

      this.openGlobalLoad()
      this.axios.get('admin/event_schedules/report', { params })
        .then(response => {
          if (response.data)
            this.$parse.downloadByLink(response.data)
          else
            this.$notify.add(response.meta.notice)
        })
        .catch(e => this.$notify.addError(e))
        .finally(() => this.closeGlobalLoad())
    },
    buildFilters() {
      this.loadFilterAccount();
      this.loadFilterUsers();
      this.loadFilterApps();
    },
    loadFilterAccount() {
      if (this.allAccounts && this.allAccounts.data && this.allAccounts.data.length > 0) {
        this.filterAccount = this.buildFilterAccount(this.allAccounts.data);
        this.refreshTableAccountNames();
      }
    },
    refreshTableAccountNames() {
      this.tableKey += 1;
    },
    async loadFilterUsers() {
      try {
        const response = await this.axios.get('admin/users', {
          params: { per_page: 1000 }
        });

        if (response && response.data && response.data.length > 0) {
          this.filterCreatedBy = new Filter({
            key: 'createdBy',
            label: 'Usuário',
            table: response.data.map(u => [u.email, u.email])
          });
          this.filterUpdatedBy = new Filter({
            key: 'updatedBy',
            label: 'Atualizado por',
            table: response.data.map(u => [u.email, u.email])
          });
        }
      } catch (e) {
        console.error('Error loading filter users:', e)
        this.$notify.addError(e)
      }
    },
    async loadFilterApps() {
      try {
        const response = await this.axios.get('admin/apps', {
          params: { per_page: 1000 }
        });

        if (response && response.data && response.data.length > 0) {
          const uniqueApps = [...new Set(
            response.data
              .filter(app => app.app_type === 'app')
              .map(app => app.name)
              .filter(Boolean)
          )].sort();

          this.filterApp = new Filter({
            key: 'appName',
            label: 'App',
            table: uniqueApps.map(app => [app, app])
          });
        } else {
          this.filterApp = new Filter({
            key: 'appName',
            label: 'App',
            table: []
          });
        }
      } catch (e) {
        console.error('Error loading filter apps:', e)
        this.$notify.addError(e)
        this.filterApp = new Filter({
          key: 'appName',
          label: 'App',
          table: []
        });
      }
    },
    find() {
      this.asyncTemplateSelect()
    },
    updateNumberOfBadges(amount) {
      this.numberOfBadges = amount
    },
    updateOrder() {
      this.find()
    }
  },
  inject: ['allAccounts', 'buildFilterAccount', 'getAccountName'],
  mixins: [GetAccount, ModelMapper, CheckedModels, GlobalLoading],
  name: 'Index',
  watch: {
    allAccounts: {
      deep: true,
      handler(newValue, oldValue) {
        this.filterAccount = this.buildFilterAccount(newValue.data)
        const oldCount = oldValue?.data?.length || 0
        const newCount = newValue?.data?.length || 0
        if (newCount > 0 && (oldCount === 0 || Math.abs(newCount - oldCount) > 0)) {
          this.refreshTableAccountNames()
        }
      },
    },
    schedules(newValue, oldValue) {
      if (newValue !== oldValue)
        this.changeCheck({ checkAllRow: false })
    }
  }
}
</script>

<style scoped lang="scss">
.fa-angle-right {
  transition: transform .2s;
  margin-left: 8px;
}

.rotate-90 {
  transform: rotate(90deg);
}
</style>
